module.exports = __webpack_public_path__ + "img/01.1a55e306.png";